import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Layout from 'components/layout'
import Career from 'containers/career'

export default class CareerPage extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired
  }

  render () {
    const data = this.props.data.markdownRemark.frontmatter
    return (
      <Layout title={data.title} headerMode='dark' headerBG={false}>
        <Career {...data} />
      </Layout>
    )
  }
}

export const careerPageQuery = graphql`
  query CareerPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        heroUnit {
          heading
          image {
            publicURL
          }
        }
        ourValues {
          heading
          values {
            icon {
              publicURL
            }
            title
            content
          }
        }
        video
        openPositions {
          heading
          description
          items {
            name
            link
          }
        }
        getStarted {
          heading
          button {
            text
            link
          }
        }
      }
    }
  }
`
